import PageContainer from "../components/Common/PageContainer";
import DashboardLayout from "../components/DashboardLayout/DashboardLayout";

function NewAgentPage() {
  return (
    <DashboardLayout>
      <PageContainer maxWidth={false} breadcrumbs={[]}></PageContainer>
    </DashboardLayout>
  );
}

export default NewAgentPage;
